import type { ReactNode } from "react";

export interface ContainerProps {
  children: ReactNode;
  withContainer: boolean;
}

export const Container = ({ withContainer, children }: ContainerProps) =>
  withContainer ? (
    <div className="skeleton-loader--card-view__container">{children}</div>
  ) : (
    <>{children}</>
  );
